import PropTypes from 'prop-types';
import React from 'react';

import styles from './styles';

const ATag = ({ href, className, children, ...otherProps }) => (
  <a href={href} className={className} {...otherProps}>
    {children}
    <style jsx>{styles}</style>
  </a>
);

ATag.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

ATag.defaultProps = {
  children: null,
  className: null,
};

export default ATag;
